import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';

export const usersRoutes: Routes = [
  {
    path: 'users',
    title: 'Benutzer',
    loadComponent: () => import('./users-list/users-list').then(m => m.UsersListComponent),
    canActivate: [authGuard],
  },
];
